import Peer from "peerjs";
import Network from "../services/Network";
import store from "../state";
import { setVideoConnected } from "../state/UserStore";

let tempAudioEnable = false;
let tempVideoEnable = false;
export default class WebRTC {
  private myPeer: Peer;
  private peers = new Map<
    string,
    { call: Peer.MediaConnection; video: HTMLVideoElement }
  >();
  private onCalledPeers = new Map<
    string,
    { call: Peer.MediaConnection; video: HTMLVideoElement }
  >();
  private videoGrid = document.querySelector(".video-grid");
  private buttonGrid = document.querySelector(".button-grid");
  private myVideo = document.createElement("video");
  private myStream?: MediaStream;
  private network: Network;

  constructor(userId: string, network: Network) {
    const sanitizedId = this.replaceInvalidId(userId);
    let options={

      "iceServers": [
      {
        url: 'stun:global.stun.twilio.com:3478?transport=udp',
        urls: 'stun:global.stun.twilio.com:3478?transport=udp'
      },
      {
        url: 'turn:global.turn.twilio.com:3478?transport=udp',
        username: 'dc174c346aeb6b799af081b3b436ea5440999ef8c76c50c14cbce862099f12c1',
        urls: 'turn:global.turn.twilio.com:3478?transport=udp',
        credential: 'HRL9swWD8eYnz9jtJwtAoMquJV0WXcp709xJbYA+9/g='
      },
      {
        url: 'turn:global.turn.twilio.com:3478?transport=tcp',
        username: 'dc174c346aeb6b799af081b3b436ea5440999ef8c76c50c14cbce862099f12c1',
        urls: 'turn:global.turn.twilio.com:3478?transport=tcp',
        credential: 'HRL9swWD8eYnz9jtJwtAoMquJV0WXcp709xJbYA+9/g='
      },
      {
        url: 'turn:global.turn.twilio.com:443?transport=tcp',
        username: 'dc174c346aeb6b799af081b3b436ea5440999ef8c76c50c14cbce862099f12c1',
        urls: 'turn:global.turn.twilio.com:443?transport=tcp',
        credential: 'HRL9swWD8eYnz9jtJwtAoMquJV0WXcp709xJbYA+9/g='
      }
    ]}
    this.myPeer = new Peer(sanitizedId,  {   host: 'rtc.supa.foundation',
    port: 443,
    path: '/ws',
    secure: true,
    "config" : options } );
    console.log(this.myPeer,"myPeer")
    this.network = network;
    console.log("userId2:", userId);
    console.log("sanitizedId2:", sanitizedId);
    this.myPeer.on("error", (err) => {
      console.log(err.type);
      console.error(err);
    });

    // mute your own video stream (you don't want to hear yourself)
    this.myVideo.muted = true;

    // config peerJS
    this.initialize();

  }

  // PeerJS throws invalid_id error if it contains some characters such as that colyseus generates.
  // https://peerjs.com/docs.html#peer-id
  private replaceInvalidId(userId: string) {
    return userId.replace(/[^0-9a-z]/gi, "G");
  }

  initialize() {
    this.myPeer.on("call", (call) => {
      if (!this.onCalledPeers.has(call.peer)) {
        call.answer(this.myStream);
        const video = document.createElement("video");
        this.onCalledPeers.set(call.peer, { call, video });

        call.on("stream", (userVideoStream) => {
          this.addVideoStream(video, userVideoStream);
        });
      }
      // on close is triggered manually with deleteOnCalledVideoStream()
    });
  }

  // check if permission has been granted before
  checkPreviousPermission() {
    const permissionName = "microphone" as PermissionName;
    navigator.permissions?.query({ name: permissionName }).then((result) => {
      if (result.state === "granted") this.getUserMedia(false);
    });
  }

  getUserMedia(alertOnError = true) {
    // ask the browser to get user media
    navigator.mediaDevices
      ?.getUserMedia({
        video: true,
        audio: true,
      })
      .then((stream) => {
        this.myStream = stream;
        this.addVideoStream(this.myVideo, this.myStream);
        this.setUpButtons();
        this.myStream.getAudioTracks()[0].enabled = tempAudioEnable;
        this.myStream.getVideoTracks()[0].enabled = tempVideoEnable;
        store.dispatch(setVideoConnected(true));
        this.network.videoConnected();
      })
      .catch((error) => {
        if (alertOnError)
          window.alert(
            "No webcam or microphone found, or permission is blocked"
          );
      });
  }

  // method to call a peer
  connectToNewUser(userId: string) {
    if (this.myStream) {
      const sanitizedId = this.replaceInvalidId(userId);
      if (!this.peers.has(sanitizedId)) {
        console.log("calling", sanitizedId);
        const call = this.myPeer.call(sanitizedId, this.myStream);
        const video = document.createElement("video");
        this.peers.set(sanitizedId, { call, video });

        call.on("stream", (userVideoStream) => {
          this.addVideoStream(video, userVideoStream);
        });

        // on close is triggered manually with deleteVideoStream()
      }
    }
  }

  // method to add new video stream to videoGrid div
  addVideoStream(video: HTMLVideoElement, stream: MediaStream) {
    video.srcObject = stream;
    video.addEventListener("loadedmetadata", () => {
      video.play();
    });
    if (this.videoGrid) this.videoGrid.append(video);
  }

  // method to remove video stream (when we are the host of the call)
  deleteVideoStream(userId: string) {
    const sanitizedId = this.replaceInvalidId(userId);
    if (this.peers.has(sanitizedId)) {
      const peer = this.peers.get(sanitizedId);
      peer?.call.close();
      peer?.video.remove();
      this.peers.delete(sanitizedId);
    }
  }

  // method to remove video stream (when we are the guest of the call)
  deleteOnCalledVideoStream(userId: string) {
    const sanitizedId = this.replaceInvalidId(userId);
    if (this.onCalledPeers.has(sanitizedId)) {
      const onCalledPeer = this.onCalledPeers.get(sanitizedId);
      onCalledPeer?.call.close();
      onCalledPeer?.video.remove();
      this.onCalledPeers.delete(sanitizedId);
    }
  }

  // method to set up mute/unmute and video on/off buttons
  setUpButtons() {
    const audioButton = document.createElement("button");
    audioButton.innerText = "Turn Mic On";
    audioButton.addEventListener("click", () => {
      if (this.myStream) {
        const audioTrack = this.myStream.getAudioTracks()[0];
        if (audioTrack.enabled) {
          audioTrack.enabled = false;
          audioButton.innerText = "Mic On";
        } else {
          audioTrack.enabled = true;
          audioButton.innerText = "Mic Off";
        }
      }
    });
    const videoButton = document.createElement("button");
    videoButton.innerText = "Turn Video On";
    videoButton.addEventListener("click", () => {
      if (this.myStream) {
        const audioTrack = this.myStream.getVideoTracks()[0];
        if (audioTrack.enabled) {
          audioTrack.enabled = false;
          videoButton.innerText = "Video On";
        } else {
          audioTrack.enabled = true;
          videoButton.innerText = "Video Off";
        }
      }
    });
    this.buttonGrid?.append(audioButton);
    this.buttonGrid?.append(videoButton);
  }
}
